import Card from "components/card";
import React, {useMemo, useState} from "react";
import {useUserAuth} from "../../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import useAsyncEffect from "use-async-effect";
import DataPointsTable from "./DataPointsTable";
import Alerts from "../../../error";
import {columnsDataFaqOverview} from "../../variables/columnsDataFaqOverview";
import FaqDataTable from "./FaqDataTable";

const FaqDataSection = (props) => {
        const {productId} = props;

        const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
        const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

        //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
        //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
        const secretKey = "cromptonssecretkey";

        let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
        const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
        const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
        const navigate = useNavigate();
        const [loading, setLoading] = useState(true);
        const [pg, setpg] = useState(0);
        const [rpg, setrpg] = useState(5);
        let [total, setTotal] = useState(0)
        let [dpInfos, setDpInfos] = useState([])

        const handleLogOut = async () => {
            try {
                await logOut();
                navigate("/");
            } catch (error) {
                ////console.log(error.message);
            }
        }

        useAsyncEffect(async () => {
                //console.log(accesscontrollevel)
                if (accesscontrollevel.toString() === "1") {
                    //console.log("Inisde USEA")
                    //console.log((JSON.parse(sessionStorage.getItem("productInfoData"))).dpInfos)

                    setDpInfos((JSON.parse(sessionStorage.getItem("productInfoData"))).faqInfos)
                    //console.log(dpInfos)
                }
                setLoading(false)

            }, []
        );

        return (

            !loading &&
            <Card extra={'w-full h-full mt-3 p-4'}>
                {accesscontrollevel.toString() === "1" ?
                    <FaqDataTable
                        tableData={dpInfos}
                        columnsData={columnsDataFaqOverview}
                        productId={productId}
                    /> : <Alerts/>}
            </Card>
        )
            ;
    }
;

export default FaqDataSection;
